import { createI18n } from 'vue-i18n';
import enMessages from './locales/en.json';
import deMessages from './locales/de.json';
import nlMessages from './locales/nl.json';
import config from '@/config';
import { get } from 'lodash-es';

const messages = {
    en: enMessages,
    de: deMessages,
    nl: nlMessages
};

const i18n = createI18n({
    legacy: false,
    locale: config.DefaultLanguage,
    fallbackLocale: 'nl',
    warnHtmlMessage: false,
    messages,
    messageResolver: (obj, path) => get(obj, path, '')?.replaceAll(/@/g, "{'@'}") || null,
});

export default i18n;
